export default "__VITE_ASSET__j2ZIXxb8__"